import React from 'react';
import ICAC from 'templates/case-studies/icac';

const ICACPage = () => (
  <ICAC />
);

export default ICACPage;
